import React from "react";
import "./carousel.css";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import HttpService from "../../HttpService";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import {
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Dropdown,
  Card,
} from "react-bootstrap";

const useStyles = makeStyles({
  root: {
    width: 50,
  },
});
const Carousel = ({ image, heading, categories, companies, history }) => {
  const [price, setPrice] = React.useState([20, 37]);

  const handlePrice = (event, newValue) => {
    setPrice(newValue);
  };
  function valuetext(value) {
    return `${value}°C`;
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    let url = "/categories/add";

    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div>
      <div className="container-fluid " style={{ width: "100%", padding: 0 }}>
        <div className="row">
          <div className="container-fluid ">
            <div
              id="carousel"
              className="carousel slide carousel-fade"
              data-ride="carousel"
              data-interval="6000"
            >
              <div className="carousel-inner" role="listbox">
                <div className="carousel-item active">
                  <a href="#">
                    <img
                      src={image}
                      alt="responsive image"
                      className="d-block img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
